import React, { useContext } from 'react';
import Gif from 'components/Gif';
import GifsContext from 'context/GifsContext';

export default function Detail({ params }) {
  const { gifs } = useContext(GifsContext);
  console.log(gifs);

  const gif = gifs.find(item => item.id === params.id);

  console.log(gif);

  return (
    <div>
      <h1>Detalle del gif con id {params.id}</h1>
      <Gif {...gif} />
    </div>
  );
}